export class PostPtoAccountData {
  accountBalance: number;
  lastBilledAmount: number;
  pastDue: number;
  lastBilledUsage: number;
  lastBilledRate: number;
  escalator: number;
  billMethod: string;
  routingNumber: string;
  lastFourDigits: string;
  invoiceNumber: string;
  contractEndDate: Date;
  contractStartDate: Date;
  paymentPlanData: PaymentPlanData;
  billingFee: number;
  autopay: boolean;
  expirationDate: string;
}
export class PaymentPlanData {
  startingBalance: number;
  remainingBalance: number;
  numberOfPaymentsLeft: number;
  totalPayments: number;
  lastPaymentScheduled: Date;
}
